import ServiceDetailLayout from "@/components/site/ServiceDetailLayout";

export default function MartechIntegration() {
  return (
    <ServiceDetailLayout
      eyebrow="Martech & Data"
      title="Make your marketing tools work together."
      subtitle="Xadentra helps connect your martech stack so campaigns, data, reporting, and sales workflows operate with less friction."
      cta="Review My Stack"
      seo={{
        title: "Martech Integration & Data Management | Xadentra",
        description: "Martech integration, data hygiene, consent capture, UTM frameworks, lead source architecture, and platform alignment for B2B marketing teams.",
        path: "/services/martech-integration",
      }}
      sections={[
        {
          heading: "Platform alignment",
          items: [
            "Adobe Marketo Engage and Salesforce alignment",
            "GTM and analytics tracking",
            "Form data capture and enrichment",
            "API and webhook planning",
            "Vendor evaluation and stack rationalization",
          ],
        },
        {
          heading: "Data quality & governance",
          items: [
            "UTM framework and source taxonomy",
            "Consent and privacy field capture",
            "Field standardization and naming conventions",
            "Lead source architecture (original + latest)",
            "Database hygiene and dedupe strategy",
          ],
        },
        {
          heading: "Audit & roadmap",
          items: [
            "Platform audit and recommendations",
            "Risk and compliance review (GDPR-aware)",
            "Identity resolution patterns",
            "CDP / warehouse decision support",
            "Quarterly improvement roadmap",
          ],
        },
      ]}
      related={[
        { to: "/services/salesforce-crm", label: "Salesforce & CRM Operations" },
        { to: "/services/reporting-attribution", label: "Reporting & Attribution" },
        { to: "/services/managed-services", label: "Managed Services" },
      ]}
    />
  );
}
